
import {phoneValidator} from 'razlet-sdk/lib/validation/phone-validator';
import phones from 'razlet-sdk/lib/validation/phones';

export default {
  name: 'base-phone-input',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    required: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
  },
  data() {
    return {
      country: 'ru',
      countries: ['ru', 'kg', 'en'],
      rules: {},
      rulesMap: { 'ru': 'russia', 'en': 'united kingdom', 'kg': 'kyrgyzstan'},
      validator: phoneValidator(),
      isValid: true,
    };
  },
  computed: {
    formatLabel () {
      return this.required
        ? `${this.label}*`
        : this.label;
    },
    supportedRules () {
      return phones.filter(
        phone => ['Russian', 'United Kingdom', 'Kyrgyzstan'].includes(phone.name_en)
      );
    },
    currentRule () {
      return this.rules[this.rulesMap[this.country]];
    },
    isCorrectCount () {
      if (this.value === null) return true;
      return this.value?.length < this.currentRule.count;
    },
  },
  watch: {
    country: {
      handler() {
        this.$emit('input', this.currentRule.code);
      },
    },
  },
  mounted() {
    const supportedRules = phones.filter(phone => ['Russia', 'United Kingdom', 'Kyrgyzstan'].includes(phone.name_en));
    this.rules = supportedRules.reduce((acc, rule) => ({ ...acc, [rule.name_en.toLowerCase()]: rule }), {});
    this.currentValue = this.currentRule.code;
    this.validator = phoneValidator();
  },
  methods: {
    onKeydown(e) {
      if (!this.isCorrectCount) e.preventDefault();
      if (!/^\d+$/.test(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    onInput (e) {
      const {value} = e.target;
      this.$emit('input', value);
      this.isValid = this.validator(value);
    },
  },
};
